import store from '../store'
import * as Sentry from '@sentry/react'

/**
 * Get logged user and set it to store
 * @return {axios}
 */
export default () => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/logged-user?include=links,onBoarding,sports.sport,sports.relationships,sports.locations,achievements,sfnData`)
        .then(({ data }) => (
            new Promise(resolve => {
                store.dispatch({
                    type: 'SET_AUTHED_USER',
                    user: data.data,
                    checkOnBoarding: true,
                })

                resolve(data.data)
            })
        ))
        .then(loggedUser => (
            new Promise(resolve => {
                const username = `${loggedUser.name} ${loggedUser.surname} (${loggedUser.slug})`

                Sentry.setUser({
                    ...loggedUser,
                    username: username,
                })

                resolve(loggedUser)
            })
        ))
)
